// removed by extract-text-webpack-plugin
module.exports = {"field":"ThemedSwitch--field--e5Qbiqgd","disabled":"ThemedSwitch--disabled--YIdXF5Ch","on":"ThemedSwitch--on--2M6ZfrmZ","thumb":"ThemedSwitch--thumb--2XOBgqMo","ripple":"ThemedSwitch--ripple--1LH-GePs"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/ThemedSwitch/ThemedSwitch.css
// module id = 1238
// module chunks = 2